var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pause") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pause",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.682169,324.896328 C232.682169,339.588327 220.770496,351.5 206.078497,351.5 L206.078497,351.5 C191.386498,351.5 179.474825,339.588327 179.474825,324.896328 L179.474825,187.103672 C179.474825,172.411673 191.386498,160.5 206.078497,160.5 L206.078497,160.5 C220.770496,160.5 232.682169,172.411673 232.682169,187.103672 L232.682169,324.896328 Z M332.525175,324.896328 C332.525175,339.588327 320.613502,351.5 305.921503,351.5 L305.921503,351.5 C291.229504,351.5 279.317831,339.588327 279.317831,324.896328 L279.317831,187.103672 C279.321843,172.411673 291.233516,160.5 305.921503,160.5 L305.921503,160.5 C320.613502,160.5 332.525175,172.411673 332.525175,187.103672 L332.525175,324.896328 Z",
    fill: "#333333",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.7354e50dbbe40d451c0753cb1ca3d71a.svg";
export { ForwardRef as ReactComponent };